(function () {
    // Touch: iframe swallows taps, so toggle the badge from its wrapper via inline styles
    // (reset when the viewport exceeds the mobile breakpoint).
    if (!(navigator.maxTouchPoints > 0 || 'ontouchstart' in window)) {
        return;
    }

    var mobileQuery = window.matchMedia('(max-width: 1200px)');
    var original = null;

    var resetBadge = function () {
        var badge = document.querySelector('.grecaptcha-badge');

        if (!badge || !original) {
            return;
        }

        if (original.right) {
            badge.style.setProperty(
                'right',
                original.right,
                original.priority
            );
        } else {
            badge.style.removeProperty('right');
        }

        var iframe = badge.querySelector('iframe');

        if (iframe) {
            iframe.style.removeProperty('pointer-events');
        }

        original = null;
    };

    var setCollapsed = function (collapsed) {
        var badge = document.querySelector('.grecaptcha-badge');

        if (!badge) {
            return;
        }

        if (!mobileQuery.matches) {
            resetBadge();
            return;
        }

        var iframe = badge.querySelector('iframe');

        if (!original) {
            original = {
                right: badge.style.getPropertyValue('right'),
                priority: badge.style.getPropertyPriority('right')
            };
        }

        if (iframe) {
            iframe.style.setProperty('pointer-events', 'none');
        }

        // Inline !important beats the badge's own :hover rule
        badge.style.setProperty(
            'right',
            collapsed ? '-186px' : '0',
            'important'
        );

        if (collapsed && badge.contains(document.activeElement)) {
            document.activeElement.blur();
        }
    };

    mobileQuery.addEventListener('change', function (event) {
        if (event.matches) {
            setCollapsed(true);
        } else {
            resetBadge();
        }
    });

    setTimeout(function () {
        setCollapsed(true);
    }, 500);

    document.addEventListener(
        'click',
        function (event) {
            var badge =
                event.target.closest &&
                event.target.closest('.grecaptcha-badge');

            if (badge) {
                setCollapsed(
                    badge.style.getPropertyValue('right') === '0px'
                );
            } else {
                setCollapsed(true);
            }
        },
        true
    );

    window.addEventListener(
        'scroll',
        function () {
            setCollapsed(true);
        },
        {
            passive: true
        }
    );
}());